import { Box, MenuItem, Tab, TextField, useMediaQuery } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import FotterMain from "../BaseComponents/FotterMain";
import Header from "../BaseComponents/Header";
import SEO from "../BaseComponents/SEO";
import { useLocation, useParams, useSearchParams } from "react-router-dom";
import { Modal } from "react-bootstrap";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import FacebookIcon from "@mui/icons-material/Facebook";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import YouTubeIcon from "@mui/icons-material/YouTube";
import Instagram from "@mui/icons-material/Instagram";
import { TabContext, TabList, TabPanel } from "@mui/lab";
const ContactUs = () => {
  const location = useLocation();
  console.log("location", location);
  const [searchParams, setSearchParams] = useSearchParams();
  const toTop = () => {
    window.scrollTo(0, 0);
  };
  useEffect(() => {
    toTop();
  }, []);
  const [addcity, setAdd] = useState("4");
  const handleChange = (event) => {
    setAdd(event.target.value);
  };
  const [modal, setmodal] = useState(false);

  const handleCloseSocial = () => {
    setmodal(false);
  };
  useEffect(() => {
    const social = searchParams.get("social");
    if (social && social == "true") {
      setmodal(true);
    }
  }, [location]);
  const mediumViewport = useMediaQuery("(min-width:768px)");
  const [value, setValue] = useState("1");

  const handleChanges = (event, newValue) => {
    setValue(newValue);
  };
  const ZonesalesOffice = [
    {
      zone: "NORTH ",
      value: "1",
      areaOffice: [
        {
          name: "DELHI",
          address:
            "Plot No. 5, Sector - 41 (Kasna), Greater Noida Industrial Development Area, District Gautam Budh Nagar, Uttar Pradesh - 201310",
          phone: "0120-2590312 / 2590240",
          email: "ao.del@hipp.co.in",
          gst: "09AAACH8464L1ZZ",
        },
        {
          name: "JAMMU",
          address:
            "Plot No. 50, Yard No. 6, Near SRTC Yard, Transport Nagar, Narwal, Jammu, J&K - 180006",
          phone: "0191-3511620",
          email: "ao.jmu@hipp.co.in",
          gst: "01AAACH8464L1ZI",
        },
        {
          name: "CHANDIGARH",
          address:
            "SCO-27, First Floor, Metro Plaza Citi Market Lohgarh Road, Zirakpur, District S.A.S Nagar, Punjab - 140603",
          phone: "01762-531109",
          email: "ao.chd@hipp.co.in",
          gst: "03AAACH8464L1ZE",
        },
        {
          name: "LUCKNOW",
          address:
            "80, Chandra Lok Colony, Kapurthala, Aliganj, Lucknow, Uttar Pradesh - 226024",
          phone: "0522-4720076",
          email: "ao.luk@hipp.co.in",
          gst: "09AAACH8464L1ZZ",
        },
      ],
    },
    {
      zone: "EAST ",
      value: "2",
      areaOffice: [
        {
          name: "GUWAHATI",
          address: (
            <p className="">
              Silver Oak Plaza, Space No. 306 & 307 , 3rd Floor , NH-37 ,
              Near Sarusajai Stadium, Lokhra,<br/> Guwahati - 781034, Assam
            </p>
          ),
          phone: "0361-4506004",
          email: "ao.guw@hipp.co.in",
          gst: "18AAACH8464L1Z3",
        },
        {
          name: "RANCHI",
          address:
            "Raghav Kunj, Goyal Road, Opp. Goyal Sanitary, Near Kishoreganj Chowk,Ranchi - 834001, Jharkhand.",
          phone: "0651-2214230",
          email: "ao.ranchi@hipp.co.in",
          gst: "20AAACH8464L1ZI",
        },
        {
          name: "BHUBANESWAR",
          address:
            "2nd Floor, Plot No. 62, 63, Unit-6, Ganganagar, Khordha, Bhubaneswar - 751001",
          phone: "0674-2397352",
          email: "ao.bhu@hipp.co.in",
          gst: "21AAACH8464L1ZG",
        },
        {
          name: "KOLKATA",
          address:
            "ERGO Tower, Unit no. 1503, Plot No. A1-4, 15th Floor, EP-GP Block, Sector V, Salt Lake City, Kolkata - 700091",
          phone: "033-40800030",
          email: "ao.cal@hipp.co.in",
          gst: "19AAACH8464L1ZI",
        },
      ],
    },
    {
      zone: "WEST ",
      value: "3",
      areaOffice: [
        {
          name: "MUMBAI",
          address:
            "A-212, 2nd Floor, Sagar Tech Plaza, Saki Naka, Andheri (E), Mumbai - 400072",
          phone: "022-46043223",
          email: "ao.mum@hipp.co.in",
          gst: "27AAACH8464L1Z4",
        },
        {
          name: "AHMEDABAD",
          address:
            "A-904, Siddhi Vinayak Tower,Off. S.G. Highway, Makarba, Ahmedabad - 380051, Gujarat",
          phone: "079-48000730",
          email: "ao.ahm@hipp.co.in",
          gst: "24AAACH8464L1ZA",
        },
        {
          name: "BHOPAL",
          address:
            "10, Sarnath Complex, 2nd Floor, Opposite M.P Board Office, Link Road No. 1, Shivaji Nagar, Bhopal - 462016",
          phone: "0755-4258515",
          email: "ao.bho@hipp.co.in",
          gst: "23AAACH8464L1ZC",
        },
      ],
    },
    {
      zone: "SOUTH ",
      value: "4",
      areaOffice: [
        {
          name: "COCHIN",
          address:
            "44/2214, D3, 2nd Floor, Holy Tuesday Shopping Mall, Kaloor, Ernakulam - 682 017, Cochin",
          phone: "0484-2537753 / 2537763",
          email: "ao.coch@hipp.co.in",
          gst: "32AAACH8464L1ZD",
        },
        {
          name: "BENGALURU",
          address:
            "D-07, 7th Floor, 'Solus' Jain Heights, 1st Cross, J.C. Road, Bengaluru - 560027",
          phone: "080-22217152",
          email: "ao.blr@hipp.co.in",
          gst: "29AAACH8464L1ZO",
        },
        {
          name: "CHENNAI",
          address:
            "1st Floor of Old No. 79, New No. 13, Coundamani Flats, Bhaskar Colony, Virugambakkam, Chennai - 600092",
          phone: "044-23767091 / 23767092",
          email: "ao.mad@hipp.co.in",
          gst: "33AAACH8464L1ZB",
        },
        {
          name: "HYDERABAD",
          address:
            "Plot No. 48, 2nd Floor, Above Indian Overseas Bank, West Marredpally, Secunderabad, Telangana - 500026",
          phone: "040-27803449 / 27803450",
          email: "ao.hyd@hipp.co.in",
          gst: "36AAACH8464L1ZS",
        },
      ],
    },
  ];
  const marine = {
    zone: "MARINE",
    value: "5",
    areaOffice: [
      {
        name: "ANDAMAN",
        address:
          "Honda Marine Service Centre, Survey No. 01, Govinda Nagar Village, Swaraj Dweep, Andaman & Nicobar Islands",
        phone: "7063930103",
        email: "",
        gst: "",
      },
    ],
  };
  return (
    <>
      <SEO
        title="Honda India Power Products | Contact Us"
        description="Toll Free: 1800-11-2323 | Email (Support): customer.support@hipp.co.in | Email (Sales): ho.mktg@hipp.co.in | Email (Service): ho.service@hipp.co.in"
        name="HIPP - Honda India Power"
        url="https://www.hondaindiapower.com/contact-us"
        type="Website"
      />
      <Header />
      <div className="innerpagebg pb-5">
        <div className="about__image">
          <div className="about__image-bg">
            <div className="container">
              <div className="row">
                <div className="col-md-4 col-12 mt-5">
                  <div className="bg-white mt-5 p-4 py-5">
                    <h4 className="d-block m-0 fw-bold text-uppercase mb-3 mt-2 text-start">
                      <span className="txtred">Contact</span>{" "}
                      <span className="txtdgray">Us</span>
                    </h4>
                    <div className="f18 text-start fw-bold">
                      HONDA INDIA POWER PRODUCTS LTD.
                    </div>
                    <div className="f14 mt-2">
                      (Formerly known as Honda Siel Power Products Ltd.)
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container pt-5">
          <div className="row">
            <div className="col-lg-3 col-12 mb-3">
              <div className="card rounded-0 border-0 shadow-sm p-4 mb-3">
                <h5 className="f18 fw-bold">
                  <span className="txtred">HEAD</span>{" "}
                  <span className="txtdgray">OFFICE</span>
                </h5>

                <div className="row">
                  <div className="col-lg-12 col-12 mb-3">
                    <div className="f14" style={{ lineHeight: "26px" }}>
                      Plot no 5 Sector 41 Kasna,
                      <br />
                      Greater Noida Industrial Development Area
                      <br />
                      Distt Gautam Budh Nagar ( UP)
                      <br />
                      Pin code: 201310
                      <br />
                      <span className="text-black fw-bold">
                        Telephone:
                      </span>{" "}
                      <a href="tel:01202590100" className="text-black">
                        0120-2590100
                      </a>
                    </div>
                  </div>
                  <div className="col-lg-12 col-12 mb-3">
                    <div className="f14" style={{ lineHeight: "26px" }}>
                      OEM (Engine Business)
                      <br />
                      <span className="text-black fw-bold">
                        Telephone:
                      </span>{" "}
                      <a href="tel:01202590214" className="text-black">
                        0120-2590214
                      </a>
                      <br />
                      <span className="text-black fw-bold">Email:</span>{" "}
                      <a
                        href="mailto:oem.hipp@hipp.co.in "
                        className="text-black"
                      >
                        oem.hipp@hipp.co.in{" "}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="row">
                <div className="col-lg-6 col-12 mb-3">
                  <div className="card rounded-0 border-0 shadow-sm p-4">
                    <h5 className="f18 fw-bold">
                      <span className="txtred">REACH</span>{" "}
                      <span className="txtdgray">US</span>
                    </h5>
                    <div className="f14" style={{ lineHeight: "26px" }}>
                      <span className="text-black fw-bold">Toll Free:</span>{" "}
                      <a href="tel:1800112323" className="text-black">
                        1800-11-2323
                      </a>
                      <br />
                      <span className="text-black fw-bold">
                        Email (Support):
                      </span>{" "}
                      <a
                        href="mailto:customer.support@hipp.co.in"
                        className="text-black"
                      >
                        customer.support@hipp.co.in
                      </a>
                      <br />
                      <span className="text-black fw-bold">
                        Email (Sales):
                      </span>{" "}
                      <a href="mailto:ho.mktg@hipp.co.in" className="text-black">
                        ho.mktg@hipp.co.in
                      </a>
                      <br />
                      <span className="text-black fw-bold">
                        Email (Service):
                      </span>{" "}
                      <a
                        href="mailto:ho.service@hipp.co.in"
                        className="text-black"
                      >
                        ho.service@hipp.co.in
                      </a>
                      <br />
                      <span className="text-black fw-bold"></span>
                      <br />
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-12 mb-3">
                  <div className="card rounded-0 border-0 shadow-sm p-4">
                    <h5 className="f18 fw-bold">
                      <span className="txtred">REGISTERED</span>{" "}
                      <span className="txtdgray">OFFICE</span>
                    </h5>
                    <div className="f14" style={{ lineHeight: "26px" }}>
                      409, DLF Tower B<br />
                      Jasola Commercial Complex, South Delhi
                      <br />
                      New Delhi- 110025
                      <br />
                      <span className="text-black fw-bold">CIN:</span>{" "}
                      L40103DL2004PLC203950
                    </div>
                  </div>
                </div>
              </div> */}
            </div>
            <div className="col-lg-3 col-12  ">
              <div className="card rounded-0 border-0 shadow-sm p-4">
                <h5 className="f18 fw-bold">
                  <span className="txtred">REACH</span>{" "}
                  <span className="txtdgray">US</span>
                </h5>
                <div className="f14" style={{ lineHeight: "26px" }}>
                  <span className="text-black fw-bold">Toll Free:</span>{" "}
                  <a href="tel:1800112323" className="text-black">
                    1800-11-2323
                  </a>
                  <br />
                  <span className="text-black fw-bold">
                    Grievance Officer:
                  </span>{" "}
                  <a
                    href="mailto:customer.support@hipp.co.in"
                    className="text-black"
                  >
                    customer.support@hipp.co.in
                  </a>
                  <br />
                  <span className="text-black fw-bold">
                    Email (Sales):
                  </span>{" "}
                  <a href="mailto:ho.mktg@hipp.co.in" className="text-black">
                    ho.mktg@hipp.co.in
                  </a>
                  <br />
                  <span className="text-black fw-bold">
                    Email (Service):
                  </span>{" "}
                  <a href="mailto:ho.service@hipp.co.in" className="text-black">
                    ho.service@hipp.co.in
                  </a>
                  {/* <br />
                  <span className="text-black fw-bold"></span>
                  <br /> */}
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-12  ">
              <div className="card rounded-0 border-0 shadow-sm p-4">
                <h5 className="f18 fw-bold">
                  <span className="txtred">REGISTERED</span>{" "}
                  <span className="txtdgray">OFFICE</span>
                </h5>
                <div className="f14" style={{ lineHeight: "26px" }}>
                  409, DLF Tower B<br />
                  Jasola Commercial Complex, South Delhi
                  <br />
                  New Delhi- 110025
                  <br />
                  <span className="text-black fw-bold">CIN:</span>{" "}
                  L40103DL2004PLC203950
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-12  ">
              <div className="card rounded-0 border-0 shadow-sm p-4">
                <h5 className="f18 fw-bold">
                  <span className="txtred"> HONDA</span>{" "}
                  <span className="txtdgray">MARINE WORKSHOP</span>
                </h5>
                <div className="f14" style={{ lineHeight: "26px" }}>
                  Honda Marine Service Centre, Survey No. 01, Govinda Nagar
                  Village, Swaraj Dweep, Andaman & Nicobar Islands
                  <br />
                  <span className="text-black fw-bold">Email:</span>{" "}
                  marine.service1@hipp.co.in
                  <br />
                  <span className="text-black fw-bold">Phone:</span> 7063930103
                </div>
              </div>
            </div>
            {/* <div className="col-lg-4 col-12 mb-3">
              <div className="card rounded-0 border-0 shadow-sm p-4">
                <h5 className="f18 fw-bold">
                  <span className="txtred">AREA</span>{" "}
                  <span className="txtdgray"> SALES OFFICE</span>
                </h5>
                <p>
                  Area office for inquiry and service related if not solved by
                  the dealer. For any support or problem of your Honda India
                  Power Products, please contact.
                </p>
                <div>
                  <TextField
                    id="likeTo"
                    className="w-100 mb-3"
                    select
                    label="Select City"
                    name="likeTo"
                    variant="standard"
                    value={addcity}
                    onChange={handleChange}
                  >
                    <MenuItem value="">Select City</MenuItem>
                    <MenuItem value="4">AHMEDABAD</MenuItem>
                    <MenuItem value="24">BANGALORE</MenuItem>
                    <MenuItem value="5">BHOPAL</MenuItem>
                    <MenuItem value="21">BHUBANESHWAR</MenuItem>
                    <MenuItem value="6">CHANDIGARH</MenuItem>
                    <MenuItem value="14">CHENNAI</MenuItem>
                    <MenuItem value="7">COCHIN</MenuItem>
                    <MenuItem value="8">GUWAHATI</MenuItem>
                    <MenuItem value="16">HYDERABAD</MenuItem>
                    <MenuItem value="17">JAMMU</MenuItem>
                    <MenuItem value="10">KOLKATA</MenuItem>
                    <MenuItem value="18">LUCKNOW</MenuItem>
                    <MenuItem value="11">MUMBAI</MenuItem>
                    <MenuItem value="15">NEW DELHI</MenuItem>
                    <MenuItem value="12">RANCHI</MenuItem>
                  </TextField>
                </div>
                <div>
                  {addcity == 4 ? (
                    <>
                      <div
                        id="area-office-res"
                        className="area-office-res mt-3"
                      >
                        <div className="fw-bold">AREA OFFICE: AHMEDABAD</div>
                        <div className="f14 mt-2">
                          Address :
                          <p>
                            A/904, Siddhivinayak Tower, Behind DCP office, Off.
                            S.G. Highway, Makarba, Ahmedabad - 380051
                          </p>
                          <strong>Phone No. :</strong> 079-48000730 &amp;
                          9978912986 <br />
                          <strong>Email :</strong> ao.ahm@hipp.co.in
                        </div>
                      </div>
                    </>
                  ) : null}
                  {addcity == 24 ? (
                    <>
                      <div
                        id="area-office-res"
                        className="area-office-res mt-3"
                      >
                        <div className="fw-bold">AREA OFFICE: BANGALORE</div>
                        <div className="f14 mt-2">
                          Address :
                          <p>
                            Honda India Power Products Ltd , D07, Solus, 7th
                            Floor, Opp To Stock Exchange , JC Road,
                            Bangalore-560002.
                          </p>
                          <strong>Phone No. :</strong> 080-2221 7152 & 2221 7172
                        </div>
                      </div>
                    </>
                  ) : null}
                  {addcity == 5 ? (
                    <>
                      <div
                        id="area-office-res"
                        className="area-office-res mt-3"
                      >
                        <div className="fw-bold">AREA OFFICE: BHOPAL</div>
                        <div className="f14 mt-2">
                          Address :
                          <p>
                            10 Sarnath Complex, Iind Floor, Link Road No. 1,
                            Shivaji Nagar, Bhopal -462016.
                          </p>
                          <strong>Phone No. :</strong> 0755 -4258515 <br />
                          <strong>Email :</strong> ao.bho@hipp.co.in
                        </div>
                      </div>
                    </>
                  ) : null}
                  {addcity == 21 ? (
                    <>
                      <div
                        id="area-office-res"
                        className="area-office-res mt-3"
                      >
                        <div className="fw-bold">AREA OFFICE: BHUBANESHWAR</div>
                        <div className="f14 mt-2">
                          Address :
                          <p>
                            2nd Floor, Plot No. 62 / 63, Unit - 6, Ganga Nagar,
                            Bhubaneswar -151 001
                          </p>
                          <strong>Phone No.:</strong> 0674-2397352, 2397477
                          <br />
                          <strong>Email:</strong> ao.bbsr@hipp.co.in
                        </div>
                      </div>
                    </>
                  ) : null}
                  {addcity == 6 ? (
                    <>
                      <div
                        id="area-office-res"
                        className="area-office-res mt-3"
                      >
                        <div className="fw-bold">AREA OFFICE: CHANDIGARH</div>
                        <div className="f14 mt-2">
                          Address :
                          <p>
                            Metro Plaza City Market, 1st Floor, SCO-27, Lohgarh
                            Road, Zirakpur, Dist: SAS Nagar, Punjab - 140603
                          </p>
                          <strong>Phone No.:</strong> 01762-531109
                          <br />
                          <strong>Email:</strong> ao.chd@hipp.co.in
                        </div>
                      </div>
                    </>
                  ) : null}
                  {addcity == 14 ? (
                    <>
                      <div
                        id="area-office-res"
                        className="area-office-res mt-3"
                      >
                        <div className="fw-bold">AREA OFFICE: CHENNAI</div>
                        <div className="f14 mt-2">
                          Address :
                          <p>
                            Honda India Power Products Ltd, Coundamani Flats,
                            1st Floor, Old No 79, New No :13 Bhaskar
                            Colony,Virugambakkam, Chennai-600092
                          </p>
                          <strong>Phone No.:</strong> 044-23767091/92/93
                          <br />
                          <strong>Email:</strong> ao.mad@hipp.co.in
                        </div>
                      </div>
                    </>
                  ) : null}
                  {addcity == 7 ? (
                    <>
                      <div
                        id="area-office-res"
                        className="area-office-res mt-3"
                      >
                        <div className="fw-bold">AREA OFFICE: COCHIN</div>
                        <div className="f14 mt-2">
                          Address :
                          <p>
                            Door No. 44/2214 D3, 2nd Floor,Holy Tuesday Shopping
                            Mall Kaloor, Ernakulam, Cochin-682017.
                          </p>
                          <strong>Phone No.:</strong> 0484 - 2537753 & 2537763
                          <br />
                          <strong>Email:</strong> ao.coch@hipp.co.in
                        </div>
                      </div>
                    </>
                  ) : null}
                  {addcity == 8 ? (
                    <>
                      <div
                        id="area-office-res"
                        className="area-office-res mt-3"
                      >
                        <div className="fw-bold">AREA OFFICE: GUWAHATI</div>
                        <div className="f14 mt-2">
                          Address :
                          <p>
                            Silver Oak Plaza - Space No 306 & 307,3rd floor N
                            H-37, Opposite Sarusajai Stadium, Lokhra, Guwahati
                            -781034
                          </p>
                          <strong>Phone No.:</strong> 9864022273
                          <br />
                          <strong>Email:</strong> ao.guw@hipp.co.in
                        </div>
                      </div>
                    </>
                  ) : null}

                  {addcity == 16 ? (
                    <>
                      <div
                        id="area-office-res"
                        className="area-office-res mt-3"
                      >
                        <div className="fw-bold">AREA OFFICE: HYDERABAD</div>
                        <div className="f14 mt-2">
                          Address :
                          <p>
                            Plot No.48, 2nd Floor, Above Indian Overseas Bank,
                            West Marredpally, Secunderabad, Telangana - 500026
                          </p>
                          <strong>Phone No.:</strong> 040-27803449, 27803450
                          <br />
                          <strong>Email:</strong> ao.hyd@hipp.co.in
                        </div>
                      </div>
                    </>
                  ) : null}
                  {addcity == 17 ? (
                    <>
                      <div
                        id="area-office-res"
                        className="area-office-res mt-3"
                      >
                        <div className="fw-bold">AREA OFFICE: JAMMU</div>
                        <div className="f14 mt-2">
                          Address :
                          <p>
                            Plot No.50 Transport Nagar, Narwal Jammu - 180006
                          </p>
                          <strong>Phone No.:</strong> 0191-2490058
                        </div>
                      </div>
                    </>
                  ) : null}
                  {addcity == 10 ? (
                    <>
                      <div
                        id="area-office-res"
                        className="area-office-res mt-3"
                      >
                        <div className="fw-bold">AREA OFFICE: KOLKATA</div>
                        <div className="f14 mt-2">
                          Address :
                          <p>
                            15th Floor, Unit No 1503, Ergo Tower, Salt Lake,
                            <br />
                            Sector - 5, Kolkata - 700091, West Bengal
                          </p>
                          <strong>Phone No.:</strong> 033-22522744 / 45
                          <br />
                          <strong>Email:</strong> ao.cal@hipp.co.in
                        </div>
                      </div>
                    </>
                  ) : null}
                  {addcity == 18 ? (
                    <>
                      <div
                        id="area-office-res"
                        className="area-office-res mt-3"
                      >
                        <div className="fw-bold">AREA OFFICE: LUCKNOW</div>
                        <div className="f14 mt-2">
                          Address :
                          <p>
                            80-Chandralok Colony, Kapoorthala Aliganj, Lucknow,
                            U.P. - 226024
                          </p>
                          <strong>Phone No.:</strong> 0522-2321630, 2330213
                          <br />
                          <strong>Email:</strong> aoluk@hipp.co.in
                        </div>
                      </div>
                    </>
                  ) : null}
                  {addcity == 11 ? (
                    <>
                      <div
                        id="area-office-res"
                        className="area-office-res mt-3"
                      >
                        <div className="fw-bold">AREA OFFICE: MUMBAI</div>
                        <div className="f14 mt-2">
                          Address :
                          <p>
                            A-212, 2nd Floor, Sagar Tech Plaza, Saki Naka,
                            Andheri (E), Mumbai -400 072
                          </p>
                          <strong>Phone No.:</strong> 022-28511342 / 3874/6854
                          <br />
                          <strong>Email:</strong> ao.mum@hipp.co.in
                        </div>
                      </div>
                    </>
                  ) : null}
                  {addcity == 15 ? (
                    <>
                      <div
                        id="area-office-res"
                        className="area-office-res mt-3"
                      >
                        <div className="fw-bold">AREA OFFICE: NEW DELHI</div>
                        <div className="f14 mt-2">
                          Address :
                          <p>
                            Plot No.5, Sector -41 (Kasna), Greater Noida, Pin:
                            201 306
                          </p>
                          <strong>Phone No.:</strong> 0120-2590240
                          <br />
                          <strong>Email:</strong> ao.del@hipp.co.in
                        </div>
                      </div>
                    </>
                  ) : null}
                  {addcity == 19 ? (
                    <>
                      <div
                        id="area-office-res"
                        className="area-office-res mt-3"
                      >
                        <div className="fw-bold">AREA OFFICE: PATNA</div>
                        <div className="f14 mt-2">
                          Address :
                          <p>
                            C/o Dr. Gopal Prasad Sinha, Near Hari Lal Sweets,
                            West Boring canal Road, Patna
                          </p>
                          <strong>Phone No.:</strong> 0612 - 2257001,
                          0612-2257004
                          <br />
                          <strong>Email:</strong> ao.pat@hipp.co.in
                        </div>
                      </div>
                    </>
                  ) : null}
                  {addcity == 12 ? (
                    <>
                      <div
                        id="area-office-res"
                        className="area-office-res mt-3"
                      >
                        <div className="fw-bold">AREA OFFICE: RANCHI</div>
                        <div className="f14 mt-2">
                          Address :
                          <p>
                            Raghav Kunj, Lake Road, Opposite Goyal Sanitary,
                            Near Kishoreganj Chowk, Ranchi, Jharkhand-834001
                          </p>
                          <strong>Phone No.:</strong> 0651-2214230
                          <br />
                          <strong>Email:</strong> ao.ranchi@hipp.co.in
                        </div>
                      </div>
                    </>
                  ) : null}
                </div>
              </div>
            </div> */}
            {ZonesalesOffice.map((item, index) => {
              return (
                <div className="col-lg-6 col-12 mb-3" key={index}>
                  <div className="card rounded-0 border-0 shadow-sm p-4">
                    <h5 className="f18 fw-bold">
                      <span className="txtred">{item.zone}</span>{" "}
                      <span className="txtdgray">REGION SALES OFFICE</span>
                    </h5>
                    <div className="row ">
                      {item.areaOffice.map((office, index) => {
                        return (
                          <div className="col-lg-6 col-12 mb-3">
                            <div
                              id="area-office-res"
                              className="area-office-res mt-3"
                            >
                              <div className="fw-bold">
                                AREA OFFICE: {office.name}
                              </div>
                              <div className="f14 mt-2">
                                Address :
                                <p className="text-capitalize">
                                  {office.address}
                                </p>
                                {office.phone !== "" && (
                                  <>
                                    <strong>Phone No:</strong> {office.phone}
                                  </>
                                )}
                                <br />
                                {office.email !== "" && (
                                  <>
                                    <strong>Email:</strong> {office.email}
                                  </>
                                )}
                                <br />
                                {office.gst !== "" && (
                                  <>
                                    <strong>GST:</strong> {office.gst}
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              );
            })}
            {/* <div className="col-lg-12 col-12 ">
              <div className="card rounded-0 border-0 shadow-sm p-4">
                <h5 className="f18 fw-bold">
                  <span className="txtred">AREA</span>{" "}
                  <span className="txtdgray"> SALES OFFICE</span>
                </h5>
               

                <Box sx={{ width: "100%", typography: "body1" }}>
                  <TabContext value={value}>
                    <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                      <TabList
                        onChange={handleChanges}
                        variant={mediumViewport ? "" : "scrollable"}
                        scrollButtons="auto"
                        allowScrollButtonsMobile
                        centered={mediumViewport ? true : false}
                        TabIndicatorProps={{
                          style: {
                            //display: "none",
                            backgroundColor: "#CB1100",
                          },
                        }}
                        aria-label=""
                      >
                        <Tab label="NORTH REGION" value="1" />
                        <Tab label="EAST REGION" value="2" />
                        <Tab label="WEST REGION" value="3" />
                        <Tab label="SOUTH REGION" value="4" />
                      </TabList>
                    </Box>
                    {ZonesalesOffice.map((item, index) => {
                      return (
                        <TabPanel value={item.value}>
                          <div className="row ">
                            {item.areaOffice.map((office, index) => {
                              return (
                                <div className="col-lg-3 col-12 mb-3">
                                  <div
                                    id="area-office-res"
                                    className="area-office-res mt-3"
                                  >
                                    <div className="fw-bold">
                                      AREA OFFICE: {office.name}
                                    </div>
                                    <div className="f14 mt-2">
                                      Address :<p>{office.address}</p>
                                      {office.phone !== "" && (
                                        <>
                                          <strong>Phone No:</strong>{" "}
                                          {office.phone}
                                        </>
                                      )}
                                      <br />
                                      {office.email !== "" && (
                                        <>
                                          <strong>Email:</strong>{" "}
                                          {office.email}
                                        </>
                                      )}
                                      <br />
                                      {office.gst !== "" && (
                                        <>
                                          <strong>GST:</strong> {office.gst}
                                        </>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </TabPanel>
                      );
                    })}
                  </TabContext>
                </Box>
              </div>
            </div> */}
          </div>
        </div>
      </div>
      <Modal
        size="md"
        show={modal}
        centered
        backdrop="static"
        keyboard={false}
        contentClassName="border-0 rounded-0"
        onHide={() => handleCloseSocial()}
        aria-labelledby=""
      >
        <Modal.Body className="p-4">
          <IconButton
            onClick={() => handleCloseSocial()}
            aria-label="delete"
            size="small"
            className="position-absolute top-0 end-0"
          >
            <CloseIcon fontSize="medium" />
          </IconButton>
          <div className="bg-white p-2">
            <p className="mb-3 f16 fw-bold">Follow us on social networks</p>
            <div>
              <a
                href="https://www.facebook.com/hondaindiapowerproductslimited/"
                target="_blank"
              >
                <FacebookIcon className="f28" style={{ color: "#0765FF" }} />
              </a>
              <a
                href="https://www.youtube.com/channel/UCw5zgVa0o9sqcwZxI8axfHw/"
                target="_blank"
                className=" ms-3"
              >
                <YouTubeIcon className="f28" style={{ color: "#FF0000" }} />
              </a>
              <a
                href="https://www.linkedin.com/company/honda-india-power-products-ltd/"
                target="_blank"
                className=" ms-3"
              >
                <LinkedInIcon className="f28" style={{ color: "#FF0000" }} />
              </a>
              <a
                href="https://www.instagram.com/hondaindiapowerproducts/"
                target="_blank"
                className=" ms-3"
              >
                <Instagram className="f28" style={{ color: "#F7077A" }} />
              </a>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* <div className='bg-white pt-5'>
                <div className='container'>
                    <div className="row">
                        <div className="col-md-6 col-12 mt-2 mb-2">
                            <EnqueyCel />
                        </div>
                        <div className="col-md-6 col-12 mt-2 mb-2">
                            <FindDealerCel />
                        </div>
                    </div>
                </div>
            </div> */}
      <div className="mt-5"></div>
      <FotterMain />
    </>
  );
};

export default ContactUs;
